export default {
  form: {
    agreement: {
      label:
        'Reconheço que a minha aprovação eletrónica equivale à assinatura deste documento e compreendo que a minha assinatura eletrónica é vinculativa.',
    },
    signed_by: {
      label: 'Nome',
      placeholder: 'Nome',
    },
    signer_first_name: {
      label: 'Primeiro nome',
      placeholder: 'Primeiro nome',
    },
    signer_last_name: {
      label: 'Apelido',
      placeholder: 'Apelido',
    },
    recipient_email: {
      label: 'Endereço de e-mail do destinatário',
      placeholder: 'Introduza o endereço de e-mail',
    },
    send_to_email: {
      label: 'Enviar contrato ao proprietário por e-mail ({{email}})',
    },
    additional_locations: {
      label: 'Localizações adicionais',
      placeholder: 'Pesquisar uma localização para adicionar',
    },
    special_agreements: {
      label: 'Acordos especiais',
      placeholder: 'Introduza quaisquer acordos especiais',
    },
  },
  labels: {
    name: 'Nome',
    date: 'Data',
  },
  buttons: {
    sign_in_person: 'Assine aqui com o proprietário',
    back: 'Voltar',
    edit_contract: 'Editar contrato',
    skip: 'Ignorar',
    sign: 'Assinar',
    init_sign: 'Criar contrato e enviar',
    redo: 'Refazer',
    continue: 'Continuar',
    preview: 'Pré-visualizar',
    submit: 'Submeter',
  },
  toasts: {
    failed_to_preview_contract: 'Falha ao pré-visualizar o contrato',
    contract_signing_pending: 'Aguarde, estamos a iniciar o seu contrato...',
    failed_to_sign_contract: 'Falha ao iniciar o contrato ⁉️',
    contract_got_signed: 'Contrato iniciado 👌',
  },
  in_person_signing: {
    description:
      'O proprietário recebeu esta ligação por e-mail e pode assinar remotamente. Se o proprietário estiver consigo neste momento, abra aqui a página de assinatura.',
  },
  signature_link: {
    label: 'Link de assinatura (mesmo link enviado ao destinatário por e-mail)',
    copy: 'Copiar',
    copied: 'Link de assinatura copiado para a área de transferência',
  },
  header: 'Criar contrato',
  description:
    'Reveja os detalhes do contrato e introduza o endereço de e-mail para o qual o contrato deve ser enviado.',
};
